import { TColors } from '@cian/ui-kit';
import { TConstantColors } from '@cian/ui-kit/colors/constant';

import { ESalesType } from '../../../../types/offersData';

export const getTitleColor = (salesType: ESalesType): TColors | TConstantColors => {
  switch (salesType) {
    case ESalesType.BlackFriday:
      return 'white_100';
    default:
      return 'black_100';
  }
};

export const getDescriptionColor = (salesType: ESalesType): TColors | TConstantColors => {
  switch (salesType) {
    case ESalesType.BlackFriday:
      return 'white_100';
    default:
      return 'gray60_100';
  }
};
